import React from "react";
import TextInput from "../TextInput";
import {hufRound} from "../../../utils/other";

export default class BankcardPayment extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.option && (this.props.option.amount === undefined || this.props.option.amount === null || this.props.option.amount === "")) {
            this.props.setFieldValue(String(this.props.optionIndex) + ".amount", Math.max(0, this.props.total - (this.props.cost + this.props.rounding) - (this.props.overpay > 0 ? this.props.overpay : 0)));
        }
    }

    render() {
        const amount = this.props.option.amount;
        const cost = this.props.cost;
        const total = this.props.total;
        return (
            <div className="payment bankcard-payment">
                <TextInput
                    type="number"
                    name="amount"
                    label={"Fizetendő"}
                    value={amount}
                    saveChanges={(name, value) => {
                        value = parseFloat(value || "0");
                        const cashOption = (this.props.value || []).find((v) => v.serviceprovider_type === "Cash");
                        if (cashOption) {
                            const cashOptionIndex = (this.props.value || []).findIndex((v) => v.serviceprovider_type === "Cash");
                            let cash = Math.max(0, Math.max(total - value, total - (cost - parseFloat(amount || "0")) - value));
                            cash = hufRound(cash);
                            this.props.setFieldValue(String(cashOptionIndex) + ".amount", cash);
                        }
                        this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value);
                    }}/>
            </div>
        );
    }
}